import { MutableRefObject, useEffect } from 'react'
// import { log } from '@utils/debug.ts'

const BREAKPOINT = 1060 // breakpoint for mobile resize

/**
 * Calculate the height of the breakpoint for a given HTMLDivElement element.
 *
 * @param {HTMLDivElement} element - the HTML element for which to calculate the breakpoint height
 * @return {number} the calculated height of the breakpoint
 */
const getBreakpointHeight = (element: HTMLDivElement) =>
	element.clientWidth <= BREAKPOINT
		? element.scrollHeight + 70
		: element.scrollHeight

/**
 * Set the height of the given element based on the modal and container heights,
 * and trigger a resize event if the difference in heights is within a certain threshold.
 *
 * @param {HTMLDivElement | null} element - The element to set the height for.
 * @return {void}
 */
const setHeight = (element: HTMLDivElement | null) => {
	const modalElement = document.querySelector(
		'.modal__body'
	) as HTMLDivElement | null
	const container = modalElement ?? element

	const modalHeight = modalElement?.scrollHeight || 0
	const refHeight = element?.scrollHeight || 0
	const isModalBigger = modalHeight - refHeight > 0

	if (container && modalElement && isModalBigger) {
		sendResizeEvent(getBreakpointHeight(container))
	} else if (container && !modalElement) {
		sendResizeEvent(getBreakpointHeight(container))
	}
}

/**
 * Sends a resize event after a delay, updating the parent element's height and posting the new height to the parent window if the element height is provided.
 *
 * @param {number} elementHeight - the height of the element
 */
function sendResizeEvent(elementHeight?: number) {
	setTimeout(() => {
		if (elementHeight) {
			parent.postMessage(elementHeight + 250, '*')
			//document.body.style.height = `${elementHeight}px`
		}
	}, 50)
}

/**
 * This function sets up a listener for the window resize event and triggers a
 * resize event on a given HTML element. It also logs a message and sends a
 * resize event on mount and when the element's scrollHeight changes.
 *
 * @param {MutableRefObject<HTMLDivElement | null>} ref - reference to the HTML
 * element to be resized
 * @return {void}
 */
export function useFrameResize(ref: MutableRefObject<HTMLDivElement | null>) {
	window.addEventListener('resize', () => {
		setHeight(ref.current)
	})

	useEffect(() => {
		setHeight(ref.current)
	}, [ref.current?.scrollHeight])
}

/**
 * Function to force scroll height.
 */
export function forceScrollHeight() {
	const container = document.querySelector('#stepper-main') as HTMLDivElement

	setHeight(container)
}
